<template>
  <div class="slide zoom" v-parallax-fit="parallax"></div>
</template>

<script>
export default {
  name: 'slide12',
  data() {
    return {
      parallax: [
        {
          start: 9300,
          end: 9900,
          fromStyle: { transform: 'translateY(-1400px) rotateZ(0deg) scale(0.9)' },
          toStyle: { transform: 'translateY(100px) rotateZ(8deg) scale(1.2)' },
          easing: 'linear'
        },
        {
          start: 10500,
          end: 11000,
          fromStyle: { transform: 'translateY(301px) rotateZ(8deg) scale(1)' },
          toStyle: { transform: 'translateY(1900px) rotateZ(0deg) scale(0.8)' },
          easing: 'linear'
        },
      ],
    };
  }
}
</script>

<style lang="scss" scoped>
.slide {
    position: absolute;
    transform-origin: center;
    background-image: url('/themes/rise-theme/dist/images/estate/character-view/vanessa/11_HospitalHands.png');
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
    width: 550px;
    height: 500px;
    left: -245px;
    top: 26vh;
    transition: 0.6s;
    z-index: 5;
    @media(max-width: 600px) {
      width: 200px;
      left: -165px;
      top: calc(50% - 460px);
    }
    @media(max-width: 400px) {
      left: -115px;
      top: calc(50% - 310px);
    }
}
</style>
